var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"calc(100vh - 150px)"}},[_c('w-personal-plan-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }